<script>


import {redirectToAgentLogin} from "../../../helpers/routerHelper";
import RequestAgentKitDialog from "../../common/requestAgentKitDialog.vue";

export default {
  name: "agentRegistrationSection4",
  data() {
    return {
      requestAgentDialogVisible: false
    };
  },
  methods: {
    redirectToAgentLogin,
    requestAgentKit() {
      window.scrollTo({ top:  0, behavior: "smooth" });
      // this.requestAgentDialogVisible = true;
    },
  },
  components: {RequestAgentKitDialog}

}
</script>

<template>
  <div class="cta-section">
    <el-row class="cta-section-inner">
      <el-col :span="24">
        <!-- Main CTA Section -->
        <div class="cta-main">
          <h2 class="cta-title">Join UNIFI Property Today</h2>
          <p class="cta-description">
            Be part of a forward-thinking real estate platform that's transforming how off-the-plan properties are bought and sold. Join UNIFI Property and connect with serious buyers ready to reserve their future homes online. Whether you represent a single property or a large-scale development, our platform is here to make the sales process smoother, faster, and more effective.
          </p>
        </div>

        <!-- Secondary CTA Section -->
        <div class="cta-secondary">
          <h3 class="secondary-title">Ready to Grow Your Business?</h3>
          <p class="secondary-description">
            Sign up today to start listing your off-the-plan properties with UNIFI Property. Connect with the buyers who value new, modern living options—and take your sales to the next level with our streamlined, buyer-focused platform.
          </p>
        </div>
      </el-col>
    </el-row>
    <div class="button-group">
      <el-row :gutter="30">
        <el-col   :span="12">
          <el-button
            type="primary"
            size="large"
            class="join-btn"
            @click="requestAgentKit()"
          >
            REQUEST AGENT KIT
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-button
            type="primary"
            size="large"
            class="sign-in-btn"
            @click="redirectToAgentLogin"
          >
            SIGN IN
          </el-button>
        </el-col>

      </el-row>
    </div>
<!--    <request-agent-kit-dialog v-if="requestAgentDialogVisible" :request-agent-dialog-visible="requestAgentDialogVisible" @onClose="requestAgentDialogVisible = false" />-->
  </div>

</template>

<style scoped lang="scss">
.cta-section {
  padding: 20px 20px;
}
.cta-section-inner {
  padding: 0 20px;
}
.cta-main, .cta-secondary {
  text-align: left;
  margin-bottom: 40px;
}

.cta-title {
  color: #003333;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
}

.cta-description {
  color: #003333;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 40px;
}

.secondary-title {
  color: #003333;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
}

.secondary-description {
  color: #003333;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.button-group {

  gap: 20px;
  margin: 30px 20px;
}

.join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 5px;
  padding: 10px 0;
  height: max-content;
  font: 500 14px DINosaur-a, sans-serif;
  color: #ffffff;
}

.sign-in-btn {
  width: 100%;
  background-color: #ffffff;
  border-color: #003333;
  border-radius: 5px;
  padding: 10px 0;
  height: max-content;
  font: 500 14px DINosaur-a, sans-serif;
  color: #003333;
}

</style>



// WEBPACK FOOTER //
// src/components/register/agentRegistration/agentRegistrationSection4.vue